import { isValidEmail } from '../../utils/utilities';
import { initModal, toggleModal } from '../modal';
import Loader from '../Loader/loading';
const selectors = {
    form: '[data-bis-popup]',
    messages: '[data-bis-messages]',
    title: '.modal--bis .modal__title',
    success: '[data-bis-success]',
    error: '[data-bis-error]',
};
class BackInStock extends HTMLElement {
    constructor() {
        var _a, _b;
        super();
        this.successMessage = '';
        this.errorMessage = '';
        this.onClick = () => {
            toggleModal(this.getAttribute('data-modal-id'));
        };
        this.hideMessages = () => {
            if (this.formBox) {
                this.formBox.classList.remove('bis-popup--success');
                this.formBox.classList.remove('bis-popup--error');
            }
        };
        this.showError = (message = this.errorMessage) => {
            if (this.formBox) {
                this.formBox.classList.add('bis-popup--error');
            }
            if (this.messagesBox) {
                this.messagesBox.innerHTML = message;
            }
        };
        this.showSuccess = (message = this.successMessage) => {
            if (this.formBox) {
                this.formBox.classList.add('bis-popup--success');
            }
            if (this.messagesBox) {
                this.messagesBox.innerHTML = message;
            }
            if (this.titleElem) {
                this.titleElem.style.display = 'none';
            }
        };
        this.onSubmit = (event) => {
            event.preventDefault();
            this.hideMessages();
            let email = '';
            let acceptsNewsletter = false;
            const { a, g, platform } = window.bis;
            const formElement = event.target;
            const emailField = formElement.querySelector('input[type="email"]');
            const newsletterCheckbox = formElement.querySelector('input[type="checkbox"]');
            emailField === null || emailField === void 0 ? void 0 : emailField.classList.remove('field--error');
            Loader.show();
            if (isValidEmail(emailField.value)) {
                if (emailField.value !== '') {
                    email = emailField.value;
                }
                if (newsletterCheckbox.checked) {
                    acceptsNewsletter = true;
                }
                const formUrlEncoded = (x) => Object.keys(x).reduce((p, c) => p + `&${c}=${encodeURIComponent(x[c])}`, '');
                if (a !== '' && g !== '' && email !== '' && this.getAttribute('data-klaviyo-variant-id') !== '' && this.getAttribute('data-product-id') !== '') {
                    fetch('https://a.klaviyo.com/onsite/components/back-in-stock/subscribe', {
                        method: 'POST',
                        headers: {
                            'Content-Type': 'application/x-www-form-urlencoded',
                        },
                        body: formUrlEncoded({
                            a,
                            email,
                            g,
                            variant: this.getAttribute('data-klaviyo-variant-id'),
                            product: this.getAttribute('data-product-id'),
                            platform,
                            subscribe_for_newsletter: acceptsNewsletter,
                        }),
                    })
                        .then((res) => res.json())
                        .then((data) => {
                        if (data.success) {
                            this.showSuccess();
                        }
                        else {
                            this.showError();
                        }
                        Loader.hide();
                    })
                        .catch(() => {
                        this.showError();
                        Loader.hide();
                    });
                }
                else {
                    if (a === '') {
                        console.error('Missing a value');
                    }
                    if (g === '') {
                        console.error('Missing g value');
                    }
                    if (email === '') {
                        console.error('Missing email value');
                    }
                    if (this.getAttribute('data-variant-id') === '') {
                        console.error('Missing variant id');
                    }
                    if (this.getAttribute('data-product-id') === '') {
                        console.error('Missing product id');
                    }
                    this.showError();
                    Loader.hide();
                }
            }
            else {
                Loader.hide();
                emailField.classList.add('error');
            }
        };
        this.addEventListener('click', this.onClick);
        const modalID = this.getAttribute('data-modal-id');
        const modalElement = document.querySelector(`#${modalID}`);
        if (modalElement) {
            initModal(modalID);
            this.formBox = modalElement.querySelector(selectors.form);
            if (this.formBox) {
                this.formBox.addEventListener('submit', this.onSubmit);
                this.successMessage = ((_a = this.formBox.querySelector(selectors.success)) === null || _a === void 0 ? void 0 : _a.innerHTML) || '';
                this.errorMessage = ((_b = this.formBox.querySelector(selectors.error)) === null || _b === void 0 ? void 0 : _b.innerHTML) || '';
                this.messagesBox = this.formBox.querySelector(selectors.messages);
                this.titleElem = document.querySelector(selectors.title);
                if (this.messagesBox) {
                    this.messagesBox.innerHTML = '';
                }
            }
        }
    }
}
if (!customElements.get('back-in-stock')) {
    customElements.define('back-in-stock', BackInStock);
}
export default BackInStock;
